import { ChangeEventHandler, EventHandler, FC, MouseEventHandler, useEffect, useState } from "react";
import { Feedback } from "../../store/feedback";
import { ApplicationState, AppThunkDispatch } from "../../store";
import { feedbackTypeActionCreators } from "../../actions/feedbackTypeActions";
import Suspense from "../suspense/Suspense";
import { connect, ConnectedProps } from "react-redux";
import * as ArrayHelper from "../../common/arrayHelper";

interface NegativeFeedbackFormSectionProps extends ConnectedProps<typeof connector> {
    onSubmit: (feedback: Pick<Feedback, 'feedbackTypeId' | 'userComments' | 'userCopySection'>) => void;
    extendHeight: (extend: boolean) => void;
}

const NegativeFeedbackFormSection: FC<NegativeFeedbackFormSectionProps> = (props) => {
    const [selectedFeedbackTypeId, setSelectedFeedbackTypeId] = useState(1);
    const [selectedAlternativeAnswerIndex, setSelectedAlternativeAnswerIndex] = useState(-1);
    const [comment, setComment] = useState("");
    const [copySection, setCopySection] = useState("");
    const [validationError, setValidationError] = useState<string | null>(null);

    const { feedbackTypeState, answerState } = props;
    const { readFeedbackTypes } = props;

    useEffect(() => {
        if (!feedbackTypeState.isLoading && feedbackTypeState.data === undefined) {
            readFeedbackTypes();
        }
    }, [])

    useEffect(() => {
        const validate = () => {
            if (selectedFeedbackTypeId < 1) {
                setValidationError("Please select a feedback type.");
            }
            else if (comment.length < 4) {
                setValidationError("Please enter your comments about why you are experiencing issues.");
            }
            else if (comment.length > 2000) {
                setValidationError("Your comments must be less than 2000 characters.");
            }
            else {
                setValidationError(null);
            }
        }

        validate();
    }, [selectedFeedbackTypeId, comment, setValidationError]);

    const handleFeedbackTypeSelectChange: ChangeEventHandler<HTMLSelectElement> = (event) => {
        setSelectedFeedbackTypeId(parseInt(event.currentTarget.value));
        handleExpandFeedback(parseInt(event.currentTarget.value));
    }

    const handleAlternativeAnswerSelectChange: ChangeEventHandler<HTMLSelectElement> = (event) => {
        setSelectedAlternativeAnswerIndex(parseInt(event.currentTarget.value));
    }

    const handleCommentChange: ChangeEventHandler<HTMLTextAreaElement> = (event) => {
        setComment(event.currentTarget.value);
    }

    const handleCopySectionChange: ChangeEventHandler<HTMLTextAreaElement> = (event) => {
        setCopySection(event.currentTarget.value);
    }

    const handleSubmitButtonClick: MouseEventHandler<HTMLButtonElement> = (event) => {
        event.preventDefault();

        if (validationError === null) {
            let feedback: Pick<Feedback, 'feedbackTypeId' | 'userComments' | 'userCopySection'> = {
                feedbackTypeId: selectedFeedbackTypeId,
                userComments: comment,
                userCopySection: copySection
            };

            props.onSubmit(feedback);
        }
    }

    const handleExpandFeedback = (newState: number) => {
        console.log("handleExpandFeedback NegativeForm num " + newState);
        if (newState == 2 || newState == 3 || newState == 4) {
            console.log("inside if");
            props.extendHeight(true);
        }
        else {
            console.log("inside else");
            props.extendHeight(false);
        }
    }

    return (
        <Suspense isLoading={feedbackTypeState.isLoading} error={feedbackTypeState.error} errorDisplayMessage="There was a problem loading feedback form. Please try again later." data={feedbackTypeState.data}>
            {(feedbackTypes) => (
                <>
                    <div>
                        <div className="select">
                            <label htmlFor="feedbackType">Type of Issue:<span className="requiredInputs">*</span></label>
                            <select id="feedbackType" className="feedbackSelect" onChange={handleFeedbackTypeSelectChange} value={selectedFeedbackTypeId}>
                                <option value={0} disabled hidden>Please Select...</option>
                                {feedbackTypes.map((feedbackType, index) => <option key={index} value={feedbackType.id}>{feedbackType.typeDescription}</option>)}
                            </select>
                        </div>
                    </div>

                    <label htmlFor="feedback-comment" id="labelSizeReduction">
                        Tell us about the Issue:<span className="requiredInputs">*</span>
                    </label>
                    <textarea
                        name="comment"
                        className={`${!validationError && (selectedFeedbackTypeId == 2 || selectedFeedbackTypeId == 3 || selectedFeedbackTypeId == 4) ? "noErrorTall" : ""} ${!validationError ? "noError" : ""} ${(selectedFeedbackTypeId == 2 || selectedFeedbackTypeId == 3 || selectedFeedbackTypeId == 4) ? "extendNegativeComment" : ""} } feedback-input feedbackNegative-comment`}
                        id="feedback-comment"
                        placeholder="Enter feedback here."
                        onChange={handleCommentChange}
                    />

                    <div>
                        {(selectedFeedbackTypeId == 2 || selectedFeedbackTypeId == 3 || selectedFeedbackTypeId == 4) ? (
                            <div>
                                <label htmlFor="feedback-comment" id="labelSizeReduction">
                                    Copy and paste the section of the answer impacted by this issue: (optional)
                                </label>

                                <textarea
                                    name="copySection"
                                    className=" feedback-input feedbackNegative-copySection"
                                    id="feedback-comment"
                                    placeholder="Copy section here."
                                    onChange={handleCopySectionChange}
                                /></div>
                        ) : (
                            <div></div>
                        )}
                    </div>

                    {validationError && <p className="errorMessage">{validationError}</p>}

                    <button type="submit" id="feedback-button" onClick={handleSubmitButtonClick} disabled={validationError !== null}>
                        Submit Feedback
                    </button>
                </>
            )}
        </Suspense>

    );
}

const mapStateToProps = (state: ApplicationState) => {
    const feedbackTypeState = state.feedbackType;
    const answerState = state.answer;

    return { feedbackTypeState, answerState };
}

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    readFeedbackTypes: () => {
        dispatch(feedbackTypeActionCreators.readFeedbackTypes());
    }
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(NegativeFeedbackFormSection);